const FETCH_USER_TRIALS = "user/trials/FETCH_USER_TRIALS";
const FETCH_USER_TRIALS_SUCCESS = "user/trials/FETCH_USER_TRIALS_SUCCESS";
const FETCH_USER_TRIALS_FAIL = "user/trials/FETCH_USER_TRIALS_FAIL";

const FETCH_COMPLETED_USER_TRIALS = "user/trials/FETCH_COMPLETED_USER_TRIALS";
const FETCH_COMPLETED_USER_TRIALS_SUCCESS =
  "user/trials/FETCH_COMPLETED_USER_TRIALS_SUCCESS";
const FETCH_COMPLETED_USER_TRIALS_FAIL =
  "user/trials/FETCH_COMPLETED_USER_TRIALS_FAIL";

const FETCH_TRIAL_TAGS = "user/trials/FETCH_TRIAL_TAGS";
const FETCH_TRIAL_TAGS_SUCCESS = "user/trials/FETCH_TRIAL_TAGS_SUCCESS";
const FETCH_TRIAL_TAGS_FAIL = "user/trials/FETCH_TRIAL_TAGS_FAIL";

const initialState = {
  pending: true,
  loaded: false,
  trials: [],
  completed_trials: [],
  errors: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_TRIALS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_USER_TRIALS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        trials: { ...action.results.trials },
        errors: null
      });
    case FETCH_USER_TRIALS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case FETCH_COMPLETED_USER_TRIALS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_COMPLETED_USER_TRIALS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        completed_trials: { ...action.results.trials },
        errors: null
      });
    case FETCH_COMPLETED_USER_TRIALS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case FETCH_TRIAL_TAGS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_TRIAL_TAGS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        tags: { ...action.results },
        errors: null
      });
    case FETCH_TRIAL_TAGS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });

    default:
      return state;
  }
}

export function fetchUserTrialsPending() {
  return {
    type: FETCH_USER_TRIALS
  };
}

export function fetchUserTrialsSuccess(results) {
  return {
    type: FETCH_USER_TRIALS_SUCCESS,
    results
  };
}

export function fetchUserTrialsFail(errors) {
  return {
    type: FETCH_USER_TRIALS_FAIL,
    errors
  };
}

export function fetchCompletedUserTrialsPending() {
  return {
    type: FETCH_COMPLETED_USER_TRIALS
  };
}

export function fetchCompletedUserTrialsSuccess(results) {
  return {
    type: FETCH_COMPLETED_USER_TRIALS_SUCCESS,
    results
  };
}

export function fetchCompletedUserTrialsFail(errors) {
  return {
    type: FETCH_COMPLETED_USER_TRIALS_FAIL,
    errors
  };
}

export function fetchTrialTagsPending() {
  return {
    type: FETCH_TRIAL_TAGS
  };
}

export function fetchTrialTagsSuccess(results) {
  return {
    type: FETCH_TRIAL_TAGS_SUCCESS,
    results
  };
}

export function fetchTrialTagsFail(errors) {
  return {
    type: FETCH_TRIAL_TAGS_FAIL,
    errors
  };
}

export const getTrials = state => state.trials;
export const getCompletedTrials = state => state.trials;
